import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Auth from '../../../../../../Layout/Auth'
// Lazy load components
const CouponsList = lazy(() => import('../Pages/CouponsList'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';

LoadingOverlay.propTypes = undefined;

function CouponsRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/settings/coupons"
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
                        <Suspense fallback={<Loading />}>
                            <CouponsList history={history} />
                        </Suspense>
                    </Auth>
                )}
            />
        </Switch>
    );
};

export default CouponsRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
